import {useState, useRef, useCallback} from 'react';

// Custom hook to create a debounced state updater
export function useDebouncedState<T>(initial: T, delay: number): [T, (newValue: T) => void] {
   const [value, setValue] = useState(initial);
   const timerRef = useRef<number | null>(null);
   const setDebouncedValue = useCallback(
      (newValue: T) => {
         if (timerRef.current) {
            clearTimeout(timerRef.current);
         }
         timerRef.current = window.setTimeout(() => {
            setValue(newValue);
         }, delay);
      },
      [delay]
   );
   return [value, setDebouncedValue];
}
